// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__LYgfQ"};